import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Button,
} from '@/shared/components';
import CryptoTestIcon from '@/shared/assets/diamond-icon.svg?react';
import { useTranslation } from 'react-i18next';

type Props = {
  startTest: () => void;
};

const VerificationQuestionariesStart = ({ startTest }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-[43rem] max-w-[48rem] relative">
      <div className="flex flex-col items-center justify-center gap-[2.4rem] flex-1">
        <div className="flex items-center justify-center text-foreground">
          <CryptoTestIcon className="size-26" />
        </div>

        <DialogHeader className="flex flex-col items-center gap-2 ">
          <DialogTitle className="headline4 text-center text-foreground">
            {t('personalAccount.verification.questionariesStart.title')}
          </DialogTitle>
          <DialogDescription className="p4 text-center text-muted-foreground max-w-[40rem]">
            {t('personalAccount.verification.questionariesStart.description')}
          </DialogDescription>
        </DialogHeader>
      </div>

      <Button onClick={startTest} size="lg" className="w-full">
        {t('personalAccount.verification.questionariesStart.submitButton')}
      </Button>
    </div>
  );
};

export { VerificationQuestionariesStart };
